import React, { useState, useEffect, useCallback } from "react";
import { useAuth } from "../context/AuthContext";
import axios from "axios";

var BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function SpoilerShield() {
  const { getToken } = useAuth();
  const [shields, setShields] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState(null);

  const load = useCallback(async () => {
    try {
      setLoading(true);
      const token = await getToken();
      if (!token) { setLoading(false); return; }
      const res = await axios.get(BACKEND_URL + "/api/spoiler/shield", {
        headers: { Authorization: "Bearer " + token },
        timeout: 30000,
      });
      setShields(res.data.shields || []);
      setErr(null);
    } catch (e) {
      setErr("Couldn't load your shield list.");
    } finally {
      setLoading(false);
    }
  }, [getToken]);

  useEffect(() => { load(); }, [load]);

  return (
    <div style={{ maxWidth: 780, margin: "0 auto", padding: "24px 16px", color: "#fff" }}>
      <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 6 }}>
        <span style={{ fontSize: 28 }}>🛡️</span>
        <h1 style={{ fontSize: 26, fontWeight: 800, margin: 0 }}>Spoiler Shield</h1>
      </div>
      <p style={{ color: "#a1a1aa", marginTop: 0, marginBottom: 24, lineHeight: 1.5 }}>
        The Qude browser extension hides posts, videos, and search results about
        shows you haven't finished — on Reddit, YouTube, and Google. As you watch
        and Qude tracks your progress, finished shows drop off this list and their
        discussion unmasks automatically. No other tracker knows exactly where you
        are in every show, so no other tracker can do this.
      </p>

      {loading && <div style={{ color: "#a1a1aa" }}>Loading…</div>}
      {err && <div style={{ color: "#f87171" }}>{err}</div>}

      {!loading && !err && shields.length === 0 && (
        <div style={{ background: "#18181b", border: "1px solid #27272a", borderRadius: 14, padding: 20, color: "#a1a1aa" }}>
          Nothing shielded yet. Start watching a show and it'll appear here —
          protected everywhere until you finish it.
        </div>
      )}

      {!loading && shields.length > 0 && (
        <>
          <div style={{ color: "#a1a1aa", fontSize: 13, marginBottom: 10 }}>
            {shields.length} show{shields.length === 1 ? "" : "s"} protected right now
          </div>
          <div style={{ display: "grid", gap: 10 }}>
            {shields.map((s, i) => (
              <div key={s.tmdb_id || s.title || i}
                style={{ display: "flex", justifyContent: "space-between", alignItems: "center",
                  background: "#18181b", border: "1px solid #27272a", borderRadius: 12, padding: "14px 16px" }}>
                <div style={{ fontWeight: 600 }}>{s.title}</div>
                <div style={{ color: "#a78bfa", fontSize: 13 }}>
                  {s.season && s.episode ? `You're on S${s.season}E${s.episode}` : "In progress"}
                </div>
              </div>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
